import { Component, Input, forwardRef } from '@angular/core';
import { Observable } from 'rxjs';
import { SafeHtml } from '@angular/platform-browser';
import { DashboardBaseComponent } from '../shared/dashboard-base-component';
import {ProgressBarModule} from "primeng/progressbar";
import {AsyncPipe, DecimalPipe, NgClass} from "@angular/common";
import { SvgIconService } from '../utils/svg-icon.service';

export interface TarjetaKpiData {
  /** Título de la tarjeta */
  label: string;
  /** Valor principal (ej. '$3.2M', '87%') */
  value: string;
  /** Texto secundario debajo del valor */
  sub?: string;
  /** Variante de color: '' default · 'g' green · 'a' amber · 'c' cyan · 'p' purple  'r' red */
  variant: '' | 'g' | 'a' | 'c' | 'p' | 'r';
  /** Ruta a imagen para el ícono (SVG/PNG). Excluye iconClass. */
  iconSrc?: string;
  /** Clase de ícono PrimeNG sin el prefijo 'pi', ej. 'pi-car'. Excluye iconSrc. */
  iconClass?: string;
  /** Texto del pill superior derecho (ej. '1.086 ops') */
  pill?: string;
  /** Valor 0-100 para mostrar una barra de progreso y % junto al sub */
  progressValue?: number;
}

@Component({
  selector: 'app-tarjeta-kpi',
  templateUrl: './tarjeta-kpi.component.html',
  styleUrls: ['./tarjeta-kpi.component.scss'],
  standalone: true,
  imports: [
    ProgressBarModule,
    DecimalPipe,
    NgClass,
    AsyncPipe
  ],
  providers: [
    {
      provide: DashboardBaseComponent,
      useExisting: forwardRef(() => TarjetaKpiComponent)
    }
  ]
})
export class TarjetaKpiComponent extends DashboardBaseComponent {
  private _data!: TarjetaKpiData;
  iconHtml$?: Observable<SafeHtml>;
  constructor(private readonly svgIconService: SvgIconService) {
    super();
  }

  @Input() set data(val: TarjetaKpiData) {
    this._data = val;
    if (val) this.isLoaded = true;
    this.iconHtml$ = val?.iconSrc ? this.svgIconService.get(val.iconSrc) : undefined;
  }
  get data() { return this._data; }
}
